/*
Interface to get values for the current environment
*/

class EnvStorageValueGetterInterface {
    get = (key) => {
        throw new Error("get method not implemented");
    }
}

export default EnvStorageValueGetterInterface;